import {
  Box, Card, TextField, MenuItem, Button, Chip, Stack, Typography,
} from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'

const PERIODS = [
  { value: 'all', label: 'All time' },
  { value: '7',   label: 'Last 7 days' },
  { value: '14',  label: 'Last 14 days' },
  { value: '30',  label: 'Last 30 days' },
  { value: '90',  label: 'Last 90 days' },
  { value: '180', label: 'Last 6 months' },
  { value: '365', label: 'Last 12 months' },
]

// Barra de 8 filtros em cascata. `options` traz, por campo, apenas os valores
// que existem dados os outros filtros ativos (calculado no App).
export default function DashboardFilterBar({ filters, setFilters, options, onReset }) {
  const set = (key) => (e) => setFilters((f) => ({ ...f, [key]: e.target.value }))

  const field = (key, label, allLabel) => (
    <TextField
      select size="small" label={label} value={filters[key]} onChange={set(key)}
      sx={{ minWidth: 130, flex: '1 1 130px' }}
    >
      <MenuItem value="">{allLabel}</MenuItem>
      {(options[key] ?? []).map((o) => <MenuItem key={o} value={o}>{o}</MenuItem>)}
    </TextField>
  )

  const activeChips = [
    ['vendor', 'Vendor'], ['team', 'Team'], ['type', 'Type'], ['side', 'Side'],
    ['tech', 'Tech'], ['owner', 'Owner'], ['status', 'Status'],
  ].filter(([k]) => filters[k])

  return (
    <Card elevation={0} sx={{ p: 1.5, borderRadius: 3, border: '1px solid', borderColor: 'divider', mb: 2 }}>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.2, alignItems: 'center' }}>
        {field('vendor', 'Vendor', 'All vendors')}
        {field('team',   'Team',   'All teams')}
        {field('type',   'Type',   'All types')}
        {field('side',   'Side',   'All sides')}
        {field('tech',   'Technology', 'All tech')}
        {field('owner',  'Activity owner', 'All owners')}
        {field('status', 'Status', 'All statuses')}
        <TextField select size="small" label="Period" value={filters.period} onChange={set('period')} sx={{ minWidth: 130, flex: '1 1 130px' }}>
          {PERIODS.map((p) => <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>)}
        </TextField>
        <Button startIcon={<RefreshIcon />} size="small" onClick={onReset} sx={{ ml: 'auto' }}>
          Clear filters
        </Button>
      </Box>

      <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', gap: 1, mt: 1.2 }}>
        {activeChips.length === 0 && filters.period === 'all' ? (
          <Typography sx={{ fontSize: 12, color: 'text.disabled' }}>No active filters · showing everything</Typography>
        ) : (
          <>
            {activeChips.map(([k, lbl]) => (
              <Chip key={k} size="small" label={`${lbl}: ${filters[k]}`} onDelete={() => setFilters((f) => ({ ...f, [k]: '' }))} sx={{ bgcolor: 'primary.light', color: 'primary.dark' }} />
            ))}
            {filters.period !== 'all' && (
              <Chip size="small" label={PERIODS.find((p) => p.value === filters.period)?.label} onDelete={() => setFilters((f) => ({ ...f, period: 'all' }))} sx={{ bgcolor: 'primary.light', color: 'primary.dark' }} />
            )}
          </>
        )}
      </Stack>
    </Card>
  )
}
